var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSoftBounce = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 0.75L9.24196 6.25804C8.96475 6.53525 8.82614 6.67386 8.66631 6.72579C8.52572 6.77147 8.37428 6.77147 8.23369 6.72579C8.07386 6.67386 7.93525 6.53525 7.65804 6.25804L5.74196 4.34196C5.46475 4.06475 5.32614 3.92614 5.16631 3.87421C5.02572 3.82853 4.87428 3.82853 4.73369 3.87421C4.57386 3.92614 4.43525 4.06475 4.15804 4.34196L0.75 7.75M14.75 0.75H9.85M14.75 0.75V5.65",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSoftBounce, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/soft-bounce.8aa32418.svg";
export { ForwardRef as ReactComponent };